// extracted by mini-css-extract-plugin
module.exports = {"videoCaption":"videoCaption_videoCaption__27N5G"};